export default __webpack_public_path__ + "media/images/icons/arrow-white-80724e09dac246333cb0a99338001d77.svg";